
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/freight-dictionary",
      function () {
        return require("private-next-pages/freight-dictionary/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/freight-dictionary"])
      });
    }
  